<template>
<div :class="_class" v-bind:data-parent="parent">
    <slot v-bind:parent="parent"></slot>
</div>
</template>

<script>
export default {
    props: {
        expanded: {
            default: false
        },
        parent: {
            default: function() {
                return randomString(5)
            }
        }
    },
    computed: {
        _class: function() {
            let _class = []

            _class.push('collapse')

            if(this.expanded === true) {
                _class.push('show')
            }
            
            return _class
        }
    }
}
</script>